module.exports = __webpack_public_path__ + "static/img/img3.ce53e9a9.jpg";